import { classNames } from 'shared/lib/classNames/classNames';
import { Wrapper } from 'shared/ui/Wrapper/Wrapper';
import { AppLink } from 'shared/ui/AppLink/AppLink';
import { useApi } from 'app/api/APIProvider';
import { Button, ButtonTheme } from 'shared/ui/Button/Button';
import { ReactNode, useEffect, useState } from 'react';
import { Wallet } from 'widgets/Wallet';
import { useLocation, useNavigate } from 'react-router-dom';
import { Text, TextSize } from 'shared/ui/Text/Text';
import { useSelector } from 'react-redux';
import { getCart } from 'features/User/modal/selectors/getUserData/getUserData';
import { formatNumber } from 'shared/lib/utils/utils';
import WalletIcon from 'shared/assets/icons/header/wallet.svg';
import DonateIcon from 'shared/assets/icons/header/donate.svg';
import InvestIcon from 'shared/assets/icons/header/invest.svg';
import Moneybox from 'shared/assets/icons/header/moneyBox.svg';
import BackIcon from 'shared/assets/icons/backIcon.svg';
import Basket from 'shared/assets/icons/Basket.svg';
import GirlImg from 'shared/assets/img/header/girl-image.png';
import GirlImg2 from 'shared/assets/img/header/girl-image-2.png';
import GirlImg3 from 'shared/assets/img/header/girl-image-3.png';
import BoyImg from 'shared/assets/img/header/boy-image.png';
import BoyImg2 from 'shared/assets/img/header/boy-image-2.png';
import BoyImg3 from 'shared/assets/img/header/boy-image-3.png';
import LogOut from 'shared/assets/icons/Logout.svg';
import cls from './Header.module.scss';

interface HeaderProps {
    className?: string
}

interface IUser {
    avatar: string
    avatar_name: string
    birthday: string
    current_scene: {}
    email: string
    email_verified_at: string
    level: number
    name: string
    region: string
    sex: string
    surname: string
}

interface IWallet {
    name: string,
    icon: ReactNode,
    points: number,
    param: string,
}

export const Header = ({ className }: HeaderProps) => {
    const api = useApi();
    const navigate = useNavigate();
    const location = useLocation();
    const user = api.User;
    const { sum } = useSelector(getCart);
    const [pathName, setPathName] = useState<string>('/');
    // const [user, setUser] = useState<IUser>(null);
    const [wallet, setWallet] = useState<IWallet[]>(null);
    const [walletVal, setWalletVal] = useState<number>(0);
    // const [cartSum, setCartSum] = useState<number>(null);

    // const getUserData = async () => {
    //     const res = await api.GetUser();
    //     setUser(res);
    // }

    const avatars = {
        w: {
            1: GirlImg,
            2: GirlImg2,
            3: GirlImg2,
            4: GirlImg3,
        },
        m: {
            1: BoyImg,
            2: BoyImg2,
            3: BoyImg2,
            4: BoyImg3,
        },
    };

    const getWalletData = async () => {
        // const { sum } = api.LoginState === 'email_verification_needed' ? {sum: 0} : await api.GetCart();
        const {
            wallet, deposit, moneybox, nsj,
        } = await api.GetAllSum();
        // setCartSum(sum);
        setWalletVal(wallet);
        setWallet([
            {
                name: 'НСЖ',
                icon: <WalletIcon />,
                points: nsj,
                param: '/nsg',
            },
            {
                name: 'Вклад',
                icon: <DonateIcon />,
                points: deposit,
                param: '/contribution',
            },
            {
                name: 'Инвестиции',
                icon: <InvestIcon />,
                points: moneybox,
                param: '/investments',
            },
        ]);
    };

    const getUserAvatar = () => {
        //@ts-ignore
        if (user) {
            //@ts-ignore
            return avatars?.[user.avatar]?.[user.level];
        } else {
            return "";
        }
    }

    useEffect(() => {
        const { pathname } = location;
        setPathName(pathname);
        // getUserData();
        getWalletData();
    }, [location.pathname]);

    return (
        <header className={classNames(cls.Header, {}, [className])}>
            <Wrapper className={cls.wrapper}>
                <div className={cls.headerContent}>
                    {
                        pathName === '/' && (
                            <>
                                <div className={cls.profile}>
                                    <div className={cls.userImgBox}>
                                        {
                                            user && (
                                                <img src={getUserAvatar()} className={cls.userImg} alt="" />
                                            )
                                        }
                                    </div>
                                    <AppLink to={'/start'} className={cls.restartGameLink} onClick={() => {
                                            window.sessionStorage.removeItem('API_TOKEN');
                                            window.location.reload();
                                    }}>
                                        <Button
                                            theme={ButtonTheme.BACK}
                                            icon={<LogOut />}
                                            >
                                            Выход
                                        </Button>
                                    </AppLink>
                                    <div className={cls.userData}>
                                        <Text className={cls.notion} color="rgba(0, 0, 0, 0.65)" size={TextSize.text_16_600}>{ user && user.avatar_name }</Text>
                                        <Text className={cls.notion} color="rgba(0, 0, 0, 0.65)" size={TextSize.text_24_600}>
                                            { walletVal && formatNumber(walletVal) }
                                            {' '}
                                            ₽
                                        </Text>
                                    </div>
                                </div>
                            </>
                        )
                    }
                    {
                        pathName !== '/' && (
                            <div className={cls.buttonsWrapper}>
                                <Button icon={<BackIcon />} theme={ButtonTheme.BACK} onClick={() => {
                                    const subPathName = pathName.split('/')[2];
                                    if (subPathName === 'policy') {
                                        navigate('/finance');
                                    } else {
                                        navigate('/menu');
                                    }
                                }}>
                                    { (pathName === '/shop' || pathName === '/cart') ? 'В главное меню' : 'Назад'}
                                </Button>
                                <div>
                                    <Wallet sum={walletVal} name={"Баланс"} icon={<Moneybox/>} />
                                </div>
                            </div>
                        )
                    }
                    <div className={cls.servicesWrapper}>
                        {
                            pathName === '/shop'
                                ? (
                                    <AppLink to="/cart">
                                        <Wallet sum={sum} name="Корзина" icon={<Basket />} />
                                    </AppLink>
                                ) : (
                                    wallet && wallet.map(({
                                        name, icon, points, param,
                                    }, index: number) => (
                                        <AppLink to={param} key={index}>
                                            <Wallet sum={points} name={name} icon={icon} />
                                        </AppLink>
                                    ))
                                )
                        }
                    </div>
                </div>
            </Wrapper>
        </header>
    );
};
